import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgModule, ErrorHandler, provideAppInitializer, inject } from '@angular/core'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'

import { environment } from '@env/environment'
import { AppRoutingModule } from '@app/app.routing'
import { AppComponent } from '@app/app.component'
import { CoreModule } from './core/core.module'
import { SharedModule } from './shared/shared.module'
import { LoggedResolverService } from './core/_services/logged-resolver.service'
import { FIREBASE_APP } from './core/_services/firebase.providers'
import { ServiceWorkerModule } from '@angular/service-worker'
import * as Sentry from '@sentry/angular'
import { Router } from '@angular/router'
import { RightPanelComponent } from './right-panel/right-panel.component'
import { NavigationComponent } from './navigation/navigation.component'
import { LeftPanelComponent } from './left-panel/left-panel.component'
import { DashboardComponent } from './routes/dashboard/dashboard.component'
import { DialogService } from 'primeng/dynamicdialog'
import { MessageService } from 'primeng/api'
import { ToastModule } from 'primeng/toast'
import { MobileDrawerComponent } from './right-panel/components/mobile-drawer/mobile-drawer.component'
import { UpcomingSessionPanelComponent } from './left-panel/components/upcoming-session-panel/upcoming-session-panel.component'
import { WelcomeChecklistSidebarComponent } from './new-welcome-checklist/welcome-checklist-sidebar/welcome-checklist-sidebar.component'
import { GroupMeetingsSidebarComponent } from './left-panel/components/group-meetings-sidebar/group-meetings-sidebar.component'
import { YearInFocusSidebarComponent } from './shared-dialogs/year-in-review/year-in-focus-sidebar.component'
import { SystemBannerComponent } from './shared/components/system-banner/system-banner.component'
import { DarkModeService } from './core/_services/dark-mode.service'
import { BannersComponent } from './shared/components/banners/banners.component'
import { providePrimeNG } from 'primeng/config'
import myCustomTheme from '@app/focusmate-theme'

@NgModule({
    declarations: [AppComponent],
    exports: [FormsModule],
    bootstrap: [AppComponent],
    imports: [
        WelcomeChecklistSidebarComponent,
        GroupMeetingsSidebarComponent,
        YearInFocusSidebarComponent,
        SystemBannerComponent,
        UpcomingSessionPanelComponent,
        MobileDrawerComponent,
        ToastModule,
        DashboardComponent,
        LeftPanelComponent,
        RightPanelComponent,
        NavigationComponent,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        CoreModule,
        SharedModule,
        ReactiveFormsModule,
        AppRoutingModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }),
        BannersComponent,
    ],
    providers: [
        provideAppInitializer(() => {
            inject(FIREBASE_APP) // Eagerly initialize the Firebase app at bootstrap
            const dm = inject(DarkModeService)
            dm.init() // Reads localStorage & sets fm-dark
        }),
        providePrimeNG({
            theme: {
                preset: myCustomTheme,
                options: { darkModeSelector: '.fm-dark' },
            },
        }),
        LoggedResolverService,
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: environment.sentryShowDialog,
            }),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        provideHttpClient(withInterceptorsFromDi()),
        DialogService,
        MessageService,
    ],
})
export class AppModule {
    constructor(trace: Sentry.TraceService) {}
}
